// ** On-screen build-version badge (frontend only).
//    __BUILD_DATE__ is injected at build time by config-overrides.js
//    (UTC build timestamp). Falls back to 'dev build' when running unbuilt.
/* eslint-disable no-undef */
const date = typeof __BUILD_DATE__ !== 'undefined' ? __BUILD_DATE__ : 'dev build'

const VersionBadge = () => (
  <div
    style={{
      position: 'fixed',
      bottom: 3,
      right: 8,
      zIndex: 2000,
      fontSize: '10px',
      lineHeight: '12px',
      fontFamily: 'monospace',
      color: '#b9b9c3',
      opacity: 0.75,
      pointerEvents: 'none',
      userSelect: 'none'
    }}
  >
    build {date}
  </div>
)

export default VersionBadge
